import styled from 'styled-components';
import {mobileMedia} from '../../../../globalVariables/GlobalVariables';
import {dFlex, alignCenter} from '../../../../globalVariables/GlobalFlex';

/* physical right by request (page is RTL, inset-inline-end would land left).
   Lives inside the carousel's cardArea (overlay). --card-top-gap (set by useFitScale)
   is the space above the vertically-centered card: top aligns the button with the
   card's top edge, and right repeats the full visual top spacing (stage padding + gap)
   so the button sits at the same distance from both screen edges. */
export const printButton = styled.button`
    position: absolute;
    top: var(--card-top-gap, 0px);
    right: calc(var(--space-md) + env(safe-area-inset-top) + var(--card-top-gap, 0px));
    z-index: 40;
    ${dFlex}
    ${alignCenter}
    gap: var(--space-sm);
    padding: var(--space-md) var(--space-lg);
    border: 1px solid var(--color-bg-surface-hover);
    border-radius: var(--border-radius-border-radius-full);
    cursor: pointer;
    color: var(--color-border-default);
    font-size: var(--font-size-body);
    font-weight: var(--font-weight-bold);
    white-space: nowrap;
    background: rgba(28, 28, 30, 0.55);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);
    -webkit-backdrop-filter: blur(14px) saturate(1.4);
    backdrop-filter: blur(14px) saturate(1.4);
    transition: background 0.15s ease;

    & svg {
        width: 26px;
        height: 26px;
    }

    &:hover {
        background: rgba(28, 28, 30, 0.75);
    }

    /* PC only */
    ${mobileMedia} {
        display: none;
    }

    @media print {
        display: none;
    }
`;
